import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateManualRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateManual extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Manual Therapy (97140)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateManualRow key={result.XLTMPMANO} id={result.XLTMPMANO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPMANUAL ?
            Object.keys(state.entities.notes.MLTMPMANUAL)
                .filter(key => {
                    return (state.entities.notes.MLTMPMANUAL[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPMANUAL[a].XLTMPMAORDER - state.entities.notes.MLTMPMANUAL[b].XLTMPMAORDER)
                .map(key => state.entities.notes.MLTMPMANUAL[key]) : [],
    };
}

const connectedAlTemplateManual = connect(mapStateToProps)(AlTemplateManual);
export { connectedAlTemplateManual as AlTemplateManual };

